export default "__VITE_ASSET__A26pE83c__"